enum FundingReportOptions {
    DATA_TAPE = "Data Tape",
    UTIL_REPORT_DATA = "Util Request Data",
    ANNEX5 = "Annex 5",
    ANNEX12 = "Annex 12",
    CALC_REPORTS = "Calc Reports"
}

export default FundingReportOptions;